import React, { useMemo, useState } from "react";
import { Box, Button, Modal, ModalDialog, Stack, Typography } from "@mui/joy";
import { theme } from "styles/theme";
import TaskContentV2 from "components/task/content/v2/TaskContentV2";
import { buildTaskEditorProgram } from "./taskEditorRuntime";
import type { TaskEditorState } from "./taskEditorUtils";

interface TaskEditorAIPreviewModalProps {
  open: boolean;
  state: TaskEditorState | null;
  onClose: () => void;
  onApply: () => void;
}

export default function TaskEditorAIPreviewModal({
  open,
  state,
  onClose,
  onApply,
}: TaskEditorAIPreviewModalProps) {
  const [, setMoveToIndex] = useState<number | undefined>(undefined);

  const program = useMemo(
    () => (state ? buildTaskEditorProgram(state, { showAllBlocks: true }) : null),
    [state]
  );

  if (!program || !state) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        sx={{
          width: "520px",
          maxWidth: "94vw",
          height: "85vh",
          maxHeight: "85vh",
          px: 0,
          pt: 0,
          pb: 0,
          borderRadius: "24px",
          border: 0,
          boxShadow: theme.shadow.lg,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            px: "24px",
            pt: "24px",
            pb: "12px",
            flexShrink: 0,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography
            variant="Body"
            sx={{
              fontWeight: 700,
              color: theme.vars.palette.Content.Strong,
              fontSize: "16px",
            }}
          >
            AI 생성 미리보기 — {state.title || "새 활동지"}
          </Typography>
          <Typography
            variant="Caption"
            sx={{ color: theme.vars.palette.Content.Weak, mt: "2px" }}
          >
            ID: {state.taskId} — 블록{" "}
            {state.blocks.filter((b) => b.type !== "LastCard").length}개
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            px: "16px",
            py: "16px",
            backgroundColor: theme.vars.palette.Background.Level1,
          }}
        >
          <Box
            sx={{
              maxWidth: "400px",
              mx: "auto",
            }}
          >
            <TaskContentV2
              taskKey={`ai-preview-${state.taskId}`}
              data={program.content}
              setData={() => {}}
              setMoveToIndex={setMoveToIndex}
              viewerMode="patient"
            />
          </Box>
        </Box>

        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
          sx={{
            px: "24px",
            py: "16px",
            flexShrink: 0,
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <Button
            variant="Outlined"
            color="neutral"
            onClick={onClose}
            sx={{ height: "42px", px: "20px" }}
          >
            닫기
          </Button>
          <Button
            onClick={() => {
              onApply();
              onClose();
            }}
            sx={{ height: "42px", px: "24px" }}
          >
            에디터에 적용
          </Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
